import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

export async function fetchTeCountRecords(teId, opts = {}) {
  if (!teId) return null;
  try {
    const resp = await fetch(
      `${ip_back}api/TE/${encodeURIComponent(teId)}/count-records`,
      { method: "GET", headers: authHeaders(), signal: opts.signal }
    );
    const json = await resp.json().catch(() => ({}));
    if (!resp.ok || !json?.status) return null;
    return json.data || null;
  } catch (err) {
    if (err?.name === "AbortError") throw err;
    return null;
  }
}

/**
 * @param {string} teId
 * @param {{ userId?: string|null, playerId?: string|null, count: number, countLabel?: string|null }} payload
 */
export async function saveTeCountRecord(teId, payload) {
  if (!teId) throw new Error("te_id required");
  const resp = await fetch(
    `${ip_back}api/TE/${encodeURIComponent(teId)}/count-records`,
    {
      method: "PUT",
      headers: authHeaders(),
      body: JSON.stringify({
        user_id: payload.userId || null,
        player_id: payload.playerId || null,
        count: payload.count,
        count_label: payload.countLabel ?? null,
      }),
    }
  );
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || !json?.status) {
    const err = new Error(json?.message || "Failed to save count record");
    err.code = json?.code || null;
    throw err;
  }
  return json.data || null;
}

export async function deleteTeCountRecord(teId, payload) {
  if (!teId) throw new Error("te_id required");
  const resp = await fetch(
    `${ip_back}api/TE/${encodeURIComponent(teId)}/count-records`,
    {
      method: "DELETE",
      headers: authHeaders(),
      body: JSON.stringify({
        user_id: payload.userId || null,
        player_id: payload.playerId || null,
      }),
    }
  );
  const json = await resp.json().catch(() => ({}));
  if (!resp.ok || !json?.status) {
    const err = new Error(json?.message || "Failed to delete count record");
    err.code = json?.code || null;
    throw err;
  }
  return json.data || null;
}
